export interface Testimonial {
  id: number;
  name: string;
  location: string;
  rating: number;
  text: string;
  service: string;
  initials: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Michael R.',
    location: 'Evanston, IL',
    rating: 5,
    text: 'Green World replaced our 20-year-old flat roof and did an exceptional job. Wayne was professional and kept us informed throughout the entire process. The crew was clean, efficient, and the work was completed ahead of schedule. Could not be happier.',
    service: 'Flat Roof Replacement',
    initials: 'MR',
  },
  {
    id: 2,
    name: 'Sandra K.',
    location: 'Skokie, IL',
    rating: 5,
    text: 'I had severe tuckpointing damage on my 1960s brick home. Green World came out for a free inspection, gave me a fair written estimate, and completed the repair in two days. The brickwork looks like it was just laid. Highly recommend them for masonry work.',
    service: 'Tuckpointing & Masonry',
    initials: 'SK',
  },
  {
    id: 3,
    name: 'James T.',
    location: 'Chicago (Lakeview)',
    rating: 5,
    text: 'After a storm tore off several shingles, I called Green World at 7am and they had someone out by noon for an inspection. Repairs were done the next day. Family-owned businesses like this are what Chicago is all about. Fair pricing and great communication.',
    service: 'Shingle Roof Repair',
    initials: 'JT',
  },
  {
    id: 4,
    name: 'Patricia M.',
    location: 'Oak Park, IL',
    rating: 5,
    text: 'Green World handled our commercial flat roof replacement on a tight deadline. They worked around our business hours, used quality TPO membrane, and cleaned everything up perfectly. Three years later, zero issues. These guys know what they\'re doing.',
    service: 'Commercial Roofing',
    initials: 'PM',
  },
  {
    id: 5,
    name: 'David L.',
    location: 'Park Ridge, IL',
    rating: 5,
    text: 'Hired them for new gutters and soffit replacement. The sheet metal work was precise, the new seamless gutters are perfect, and the price was very reasonable. They\'ve been doing this since 1989 and it shows — this is a team that takes real pride in their craft.',
    service: 'Sheet Metal & Gutters',
    initials: 'DL',
  },
  {
    id: 6,
    name: 'Angela B.',
    location: 'Berwyn, IL',
    rating: 5,
    text: 'After getting three quotes, Green World was the most professional and gave us the most thorough inspection report. They replaced our entire shingle roof in one day, hauled everything away, and followed up a week later. That kind of service is rare. We will use them again.',
    service: 'Shingle Roof Replacement',
    initials: 'AB',
  },
];
